import { useTranslations } from 'next-intl';

import { UiKitLabelBase } from '@/fo/ui/kit/label/base';
// import { useMediaQuery } from '@/fo/ui/mod/media/query';

import { styles } from './Title.styles';

export interface TitleProps {
  isFreeShipping?: boolean;
  /** Обработчик клика по кнопке "Удалить все" */
  onClearAll?: () => void;
}

export function Title({ isFreeShipping, onClearAll }: TitleProps) {
  const t = useTranslations();
  // const isMobile = useMediaQuery('md', 'max');
  const slots = styles();

  // TODO: если получиться лучше сделать css, без isMobile

  return (
    <div className={slots.base()}>
      <h1 className={slots.title()}>{t('cart.title')}</h1>
      {isFreeShipping && (
        <UiKitLabelBase
          className={slots.label()}
          color="brand"
        >
          {t('Free shipping')}
        </UiKitLabelBase>
      )}
      <button
        type="button"
        className={slots.actionButton()}
        onClick={onClearAll}
      >
        {t('action-all-delete')}
      </button>
    </div>
  );
}
